/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Profiles routes
 */

// Pages
import ProfilesCreation from '@nephro/pages/Profiles/ProfilesCreation';
import ProfilesViewEdit from '@nephro/pages/Profiles/ProfilesViewEdit';
import ProfilesManagement from '@nephro/pages/Profiles/ProfilesManagement';

const pathStart = '/main/profiles';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: ProfilesManagement,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: ProfilesCreation,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: ProfilesViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: ProfilesViewEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
